<template>
    <div>
        <div class="flex-row mt-3 animated fadeIn transparente">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col sm="9" md="6" lg="5" xl="4">
                        <b-card-group>
                            <b-card no-body class="p-0 pb-3">
                                <b-card-body class="pb-0">
                                    <div class="text-center">
                                        <img
                                            src="img/logo-login.png"
                                            alt="app-logo"
                                            class="mb-4"
                                        />
                                        <h4 class="mb-4">
                                            <strong>{{ appDescr }}</strong>
                                        </h4>
                                    </div>
                                    <p class="text-muted">
                                        Entre com suas credenciais
                                    </p>
                                    <app-erros-box
                                        :erros="erros"
                                        v-if="erros.length > 0"
                                    ></app-erros-box>
                                    <b-form>
                                        <div v-if="tipo == 0">
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text>
                                                        <i
                                                            class="icon-user"
                                                        ></i>
                                                    </b-input-group-text>
                                                </b-input-group-prepend>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Usuário"
                                                    v-model="usuarioInterno"
                                                    autocomplete="username"
                                                    v-mask=""
                                                />
                                            </b-input-group>
                                        </div>
                                        <div v-if="tipo == 1">
                                            <b-form-group>
                                                <b-form-radio-group
                                                    v-model="tipoAcesso"
                                                >
                                                    <b-form-radio :value="1">
                                                        <strong>
                                                            <span
                                                                >PESSOA
                                                                JURÍDICA</span
                                                            >
                                                        </strong>
                                                    </b-form-radio>
                                                    <b-form-radio :value="2">
                                                        <strong>
                                                            <span
                                                                >PESSOA
                                                                FÍSICA</span
                                                            >
                                                        </strong>
                                                    </b-form-radio>
                                                </b-form-radio-group>
                                            </b-form-group>
                                            <b-input-group
                                                class="mb-3"
                                                v-if="tipoAcesso == 1"
                                            >
                                                <b-input-group-prepend>
                                                    <b-input-group-text>
                                                        <i
                                                            class="fa fa-bank"
                                                        ></i>
                                                    </b-input-group-text>
                                                </b-input-group-prepend>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="CNPJ Fornecedor"
                                                    v-model="fornecedor"
                                                    autocomplete="fornecedor"
                                                    v-mask="[
                                                        '##.###.###/####-##'
                                                    ]"
                                                />
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text>
                                                        <i
                                                            class="icon-user"
                                                        ></i>
                                                    </b-input-group-text>
                                                </b-input-group-prepend>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="CPF Usuário"
                                                    v-model="usuarioFornecedor"
                                                    autocomplete="username"
                                                    v-mask="'###.###.###-##'"
                                                />
                                            </b-input-group>
                                        </div>
                                        <b-input-group class="mb-4">
                                            <b-input-group-prepend>
                                                <b-input-group-text>
                                                    <i class="icon-lock"></i>
                                                </b-input-group-text>
                                            </b-input-group-prepend>
                                            <input
                                                type="password"
                                                class="form-control"
                                                placeholder="Senha"
                                                v-model="senha"
                                                autocomplete="current-password"
                                            />
                                        </b-input-group>
                                        <div
                                            class="d-flex justify-content-center"
                                        >
                                            <vue-recaptcha
                                                ref="recaptcha"
                                                @verify="onCaptchaVerified"
                                                @expired="onCaptchaExpired"
                                                :sitekey="recaptchaSiteToken"
                                                :loadRecaptchaScript="true"
                                                language="pt-BR"
                                                v-if="recaptchaSiteToken"
                                            ></vue-recaptcha>
                                        </div>
                                    </b-form>
                                    <b-row v-if="tipo == 1">
                                        <b-col sm="12" md="12">
                                            <div class="mt-4 text-center">
                                                <b-button
                                                    variant="primary"
                                                    class="px-4"
                                                    @click="solicitarAcesso()"
                                                >
                                                    Solicite seu acesso
                                                </b-button>
                                            </div>
                                        </b-col>
                                        <b-col sm="12" md="12">
                                            <div class="mt-4 text-center">
                                                <b-button
                                                    variant="primary"
                                                    class="px-4"
                                                    @click="resetarSenha()"
                                                >
                                                    Esqueceu sua senha?
                                                </b-button>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <div class="mt-4 text-center">
                                                <span>
                                                    <strong
                                                        >v{{ versao }}</strong
                                                    >
                                                </span>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-card>
                        </b-card-group>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div>
            <div class="mt-3 mb-3 text-center" v-if="tipo == 1">
                <b-button variant="primary" @click="mudarAcesso()"
                    >Acesso Interno</b-button
                >
            </div>
            <div class="mt-3 mb-3 text-center" v-if="tipo == 0">
                <b-button variant="primary" @click="mudarAcesso()"
                    >Acesso Externo</b-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import LoginServicos from './LoginServicos'
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'

export default {
    name: 'Login',
    components: {
        'vue-recaptcha': VueRecaptcha
    },

    data() {
        return {
            usuarioInterno: '',
            usuarioFornecedor: '',
            senha: '',
            fornecedor: '',
            erros: [],
            versao: process.env.VUE_APP_VERSION,
            recaptchaSiteToken: null,
            recaptchaToken: '',
            appNome: process.env.VUE_APP_NOME,
            appDescr: process.env.VUE_APP_DESCR,
            tipo: 1,
            tipos: [
                { text: 'INTERNO', value: 0 },
                { text: 'FORNECEDOR', value: 1 }
            ],
            tipoAcesso: 1
        }
    },

    beforeCreate() {
        this.$store.dispatch('verificarVersao')
        axios.get('app/recaptcha.txt').then((res) => {
            this.recaptchaSiteToken = res.data
        })
    },

    mounted() {
        if (this.$route.name == 'Login') {
            this.tipo = 1
        } else if (this.$route.name == 'LoginInterno') {
            this.tipo = 0
        }
    },

    methods: {
        onCaptchaVerified(recaptchaToken) {
            this.recaptchaToken = recaptchaToken
            this.entrar()
        },

        onCaptchaExpired() {
            this.$refs.recaptcha.reset()
        },

        entrar() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.tipo == 0) {
                let loginDto = {
                    usuario: this.usuarioInterno.toLowerCase(),
                    senha: btoa(this.senha),
                    recaptchaToken: this.recaptchaToken
                }
                promisse = LoginServicos.loginInterno(loginDto)
            } else if (this.tipo == 1) {
                let loginDto = {
                    fornecedor: this.fornecedor.apenasNumeros(),
                    usuario: this.usuarioFornecedor.apenasNumeros(),
                    senha: btoa(this.senha),
                    recaptchaToken: this.recaptchaToken,
                    tipoAcesso: this.tipoAcesso
                }
                promisse = LoginServicos.loginExterno(loginDto)
            }
            promisse.then((data) => {
                if (data) {
                    if (data.success) {
                        this.$store.dispatch('login', data.data)
                        this.processarRota()
                    } else {
                        this.erros = data.errors
                    }
                }
                this.$store.dispatch('removeRequest')
                this.$refs.recaptcha.reset()
            })
        },

        processarRota() {
            if (this.$store.getters.usuario.aspl === 'True') {
                this.$router.push('/atualizarsenha')
            } else {
                this.$router.push('/')
            }
        },

        solicitarAcesso() {
            this.$router.push('/solicitacaoacesso')
        },

        resetarSenha() {
            this.$router.push('/esqueciminhasenha')
        },

        mudarAcesso() {
            if (this.tipo == 1) {
                this.tipo = 0
                this.$router.push({ name: 'LoginInterno' })
            } else {
                this.tipo = 1
                this.$router.push({ name: 'Login' })
            }
        }
    }
}
</script>
